// extracted by mini-css-extract-plugin
export default {"inbox":"JZvgGDxLerUMWyloV5Q3"};